import { mapState } from "vuex";

import formable from "@/mixins/formable";

import {
  GET_ROOM_TYPES_COLLECTION,
  GET_ROOM_TYPES_COLLECTION_2,
} from "@/store/room-types/actions";

export default {
  props: {
    propertyIds: {
      type: Array,
      required: false
    }
  },
  mixins: [
    formable
  ],
  data() {
    return {
      form: {
        room_type_id: null,
        parent_id: null,
        amount_status: 3,
        amount: 0,
        length_of_stay: 1,
        availability: 1,
        restrictions: 1,
        stop_sell: 1,
        is_round: 1,
        force_regenerate: 0,
      }
    };
  },
  beforeMount() {
    let params = {
      property_ids: this.propertyIds,
      order: 'asc',
      sortBy: 'name',
      _data: {
        selects: [
          'id',
          'name',
          'property_id'
        ],
        relations: {
          property: {
            selects: [
              'id',
              'name'
            ]
          }
        }
      }
    };

    this.$store.dispatch(GET_ROOM_TYPES_COLLECTION, params);

    if (this.itemId) {
      return false;
    }

    this.$store.dispatch(GET_ROOM_TYPES_COLLECTION_2, {
      ...params,
      is_derived: this.$const('ConstHasOptionFilters', 'FALSE')
    });
  },
  computed: {
    ...mapState({
      roomTypes: state => state.roomTypes.getCollectionRequest.collection,
      roomTypesNotDerived: state => state.roomTypes.getCollection2Request.collection,
    }),
    initialized() {
      return !!this.roomTypes.length;
    }
  },
}
